import { useEffect, useRef } from "react";
import { characterCursor } from "./characterCursor";
import { clockCursor } from "./clockCursor";

const Switch = ({ theme }) => {
  const cursorRef = useRef(null);

  useEffect(() => {
    // Clean up previous cursor effect
    if (cursorRef.current) {
      cursorRef.current.destroy();
    }

    if (theme === "light") {
      cursorRef.current = characterCursor({
        characters: ["✨", "💡", "🚀", "😊"],
        font: "18px sans-serif",
        zIndex: 9999,
      });
    } else {
      cursorRef.current = clockCursor({
        faceColor: "#00FFFF",
        secondsColor: "#FF4444",
        hoursColor: "#FFFFFF",
        minutesColor: "#AAAAAA",
        dateColor: "#FFD700",
        zIndex: 9999,
      });
    }

    return () => {
      if (cursorRef.current) cursorRef.current.destroy();
    };
  }, [theme]);

  return null;
};

export default Switch;
